<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: black;
}
.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Zine Machines</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Workshop, web tools</p>
        <p>If we let it take over, what kind of zine would a machine create? In this workshop, we explored this question through a couple of fun tools and scripts that allow us to rearrange, modify and even fully transform images, texts and sounds, in order to create unique zines.</p>
        <p>This workshop was part of <a href="http://www.spreadzinefest.nl/?utm_source=Newsletter+SIGN&utm_campaign=d6b2a38072-EMAIL_CAMPAIGN_2018_02_28_COPY_01&utm_medium=email&utm_term=0_a209f9faf4-d6b2a38072-495751117" target="_blank">Spread Zinefest 2018</a> and was held during two days at SIGN Groningen. The project was developed together with Angeliki Diakrousi and Luke Murphy.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/zinemachines/zine.gif"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/zinemachines/IMG_1310.JPG"></b-img>
      </b-col>

      <b-col md="4">
      <b-img class="img-fluid" src="media/zinemachines/IMG_1322.JPG"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/zinemachines/IMG_1316.JPG"></b-img>
      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ZineMachinesPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
